import AiSkeletonItem from 'components/AISkeletonItem'
import { COLORS } from 'consts/colors'
import styled from 'styled-components'
import { ChessGridBackground } from 'styles/consts'
import {
  convertAspectRatioForCSS,
  normalizeAndConvertAspectRatioForCSS,
  SQUARE_ASPECT_RATIO
} from 'utils/aspectRatio'

export const GeneratedImage = styled.img<{
  $isImageLoading: boolean
  $aspectRatio: string
}>`
  width: 100%;
  height: 100%;
  // we use 'cover' for other aspect ratios because media dimensions may not match
  // the aspect ratio, so we need to fill the container properly.
  object-fit: ${({ $aspectRatio }) =>
    $aspectRatio === SQUARE_ASPECT_RATIO ? 'contain' : 'cover'};
  opacity: ${({ $isImageLoading }) => ($isImageLoading ? 0 : 1)};
`

export const ImageWrapper = styled.div<{ $aspectRatio: string }>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ $aspectRatio }) => convertAspectRatioForCSS($aspectRatio)};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid ${COLORS.borderColor};

  ${ChessGridBackground}
`

export const AiImageSkeletonItem = styled(AiSkeletonItem)<{
  $aspectRatio?: string
}>`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  aspect-ratio: ${({ $aspectRatio }) =>
    normalizeAndConvertAspectRatioForCSS($aspectRatio)};
`
